<template>
  <li class="relative snap-end rounded-8 w-full mx-1 flex flex-col bg-charleston-green border-charleston-green aspect-4/3! border-4">
    <header class="absolute z-9 top-0 flex flex-row flex-1 justify-between w-full">
      <div class="absolute flex items-center justify-center flex-row gap-x-2 p-1 bg-black/25! rounded-4">
        <wui-icon
          name="clockM"
          class="text-threshold flex shrink-0"
        />
      </div>
      <button
        class="hover:opacity-50 bg-black/25! p-1 rounded-4 flex shrink-0 absolute top-0 right-0 text-white"
        data-test="awaiting-contact-card-menu-button"
        @click="onMoreClick"
      >
        <span class="sr-only select-none">{{ $t('common.openMenu') }}</span>
        <wui-icon
          name="kebabHorizontalM"
        />
      </button>
    </header>
    <main class="h-full w-full relative overflow-hidden rounded-8">
      <div class="absolute top-1/2 -translate-y-1/2 left-1/2 transform -translate-x-1/2  w-full h-full flex flex-col items-center justify-center gap-8 opacity-40!">
        <contact-avatar
          :contact="contact"
          :contact-type="contact.type"
          hide-border
          :size="48"
          class="top-if-height-small aspect-square! w-auto! border border-white relative -top-[0.6rem] h-[55%]! max-h-[128px] text-2440!"
        />
        <slot
          name="avatar-footer"
          :contact-name="contact.name"
        />
      </div>
    </main>
    <footer
      data-test="awaiting-contact-card-name"
      class="absolute bottom-0 text-center z-8 overflow-hidden left-1/2 -translate-x-1/2 w-full rounded-8 px-2 text-white bg-black text-1324 line-clamp-1"
    >
      {{ contact.name }}
    </footer>
  </li>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { toRefs, onMounted } from 'vue'

import { ContactAvatar } from '@/entities/contact-avatar'

import { Contact } from '@/shared/types/api'


const props = defineProps<{
  contact: Contact,
}>()

const emit = defineEmits<{
  (event: 'showAddNotification'): void
  (event: 'hideAddNotification'): void
  (event: 'showAddCard'): void
}>()

const { contact } = toRefs(props)

const onMoreClick = () => {
  emit('hideAddNotification')

  emit('showAddCard')
}

onMounted(() => {
  emit('showAddNotification')
  setTimeout(() => emit('hideAddNotification'), 60000)
})
</script>
